export const CHECKOUT_BOUYGUES_IN_STORE = {
  BOUYGUES_TELECOM: {
    SELF: 'checkout_in_store_sales_bouygues_telecom',
    ERROR: 'checkout_in_store_sales_bouygues_telecom_error',
    CART: 'checkout_in_store_sales_bouygues_telecom_cart',
    ADDRESSES: 'checkout_in_store_sales_bouygues_telecom_addresses',
    PAYMENT: 'checkout_in_store_sales_bouygues_telecom_payment',
    PAYMENT_RESULT: 'checkout_in_store_sales_bouygues_telecom_payment_result',
  },
}
